import React from "react";
import ListItemReversedTextView from "../../../../../common/components/ListItemReversedTextView";
import {WordFullInfo} from "../../../../../common/types/words";

export interface SrsInfoViewProps {
    fullWordInfo: WordFullInfo;
    isWordLearned: boolean;
}

export default function SrsInfoView({fullWordInfo, isWordLearned}: SrsInfoViewProps) {

    return (
        <>
            <ListItemReversedTextView title={"Stage"}
                                      content={isWordLearned ? fullWordInfo.stage!.toString() : "Not yet learned"}/>
            {isWordLearned && (
                <>
                    <ListItemReversedTextView title={"Next review"} content={(() => {
                        const now = new Date();
                        const nextReviewTime = new Date(fullWordInfo.nextReviewTime!);
                        const diff = nextReviewTime.getTime() - now.getTime();

                        if (diff <= 0) {
                            return "Available now";
                        }

                        const seconds = Math.floor(diff / 1000);
                        const minutes = Math.floor(seconds / 60);
                        const hours = Math.floor(minutes / 60);
                        const days = Math.floor(hours / 24);
                        const years = Math.floor(days / 365);

                        if (years > 0) return `${years}y`;
                        if (days > 0) return `${days}d`;
                        if (hours > 0) return `${hours}h`;
                        if (minutes > 0) return `${minutes}m`;
                        return `${seconds}s`;
                    })()}/>
                    <ListItemReversedTextView title={"Learned on"}
                                              content={new Date(fullWordInfo.learnedTime!).toLocaleDateString('en-GB', {
                                                  day: 'numeric',
                                                  month: 'short',
                                                  year: 'numeric'
                                              })}/>
                </>
            )}
        </>
    );
}
